export const environment = {
  production: true,
  apiProtocol: "https://",
  apiDomain: "api.f681e3263e1d4d0fb6669e61efcfedd1.flux.host",
  apiPath: "/api",
  mapbox: {
    accessToken: "pk.eyJ1IjoiZmx1eGhvc3QiLCJhIjoiY201dHNnOHF6MTBkazJuc2VmMWZsYWE0dCJ9.FoPjoC7H7HPLUpfSui_BPg",
  },
  auth: {
    domain: "https://flux-host-dev-cv7hru.us1.zitadel.cloud",
    clientId: "284173040957349400",
    redirectBaseUri: "https://pitstop.flux.host",
  }
};
